import { render, staticRenderFns } from "./AdditionalServiceSettingComponent.vue?vue&type=template&id=551323ec&scoped=true&"
import script from "./AdditionalServiceSettingComponent.vue?vue&type=script&lang=js&"
export * from "./AdditionalServiceSettingComponent.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalServiceSettingComponent.vue?vue&type=style&index=0&id=551323ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551323ec",
  null
  
)

export default component.exports